<template>
	<transition name="fade" key="transition.virtapp.applist" appear>
		<b-container>
			<template v-if="stackList && stackList.length">
				<h2 class="h4 mb-4">Select an application below to launch a desktop sesssion</h2>
				<b-card no-body class="mb-4" v-for="stack in stackList" :key="stack.stackName">
					<template #header>
						{{ stack.stackName }} <b-badge class="px-4 align-middle float-right" :href="'#/virtapp/launch/' + stack.stackUUID + '?app=Desktop'" variant="primary">Launch</b-badge>
					</template>
					<b-list-group flush>
						<b-list-group-item v-for="app in stack.appCatalog" :key="stack.stackName + '/' + app.name" :href="'#/virtapp/launch/' + stack.stackUUID + '?app=Desktop'">{{ app.name }}</b-list-group-item>
					</b-list-group>
				</b-card>
			</template>
			<template v-else>
				<h2 class="h4 mb-4">No applications</h2>
			</template>
		</b-container>
	</transition>
</template>

<script>
	import { RingLoader } from '@saeris/vue-spinners';
	import stateMessages from '@/components/Desktop/stateMessages';
	
	export default
	{
		name: 'virtapp-applist',
		components: { RingLoader },
		props: [ 'stack' ],
		computed:
		{
			portalAPI: function()
			{
				return this.$root.$refs.app.portalAPI;
			},
			stackAppDataPath: function()
			{
				let clientKey = this.$store.state.clientKey;
				
				return clientKey.replace(/^((.)(.).+)/, "$2/$3/$1/virtapp.json");
			},
			appList: function()
			{
				let appList = this.stackList.reduce((l, v) => l.concat(...(v.applications || []).map((appName) => { return { appName, stackName: v.stackName, stackUUID: v.stackUUID }; })), []);
				
				console.log(appList);
				
				return appList;
			}
		},
		methods:
		{
			getStackList: async function()
			{
				let result = await this.$http.get(
						'https://s3.amazonaws.com/co.elumin.sites.prd/config/' + this.stackAppDataPath,
						{ 'responseType': 'json', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '0' }
					)
					.then(
						resp => resp.data
					).catch(e => this.$logger.error(e));
				
				this.stackList = result;
			}
		},
		mounted()
		{
			this.$nextTick(this.getStackList);
		},
		data() { return { stackList: [] }; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container
	{
		height: 100%;
		max-height: 100%;
		
		overflow: auto;
		
		padding: 12px;
	}
</style>
